import { render, staticRenderFns } from "./AppUpselling.vue?vue&type=template&id=6281012e"
import script from "./AppUpselling.vue?vue&type=script&lang=js"
export * from "./AppUpselling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/rouvenpajewski/Documents/Projekte/kuipers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6281012e')) {
      api.createRecord('6281012e', component.options)
    } else {
      api.reload('6281012e', component.options)
    }
    module.hot.accept("./AppUpselling.vue?vue&type=template&id=6281012e", function () {
      api.rerender('6281012e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/vue/AppUpselling.vue"
export default component.exports